__webpack_require__.p = "/react-crypto-tracker/";